import { useContext } from "react";
import { Issuance } from "Context/context";

export default function useIssuance() {
  return useContext(Issuance);
}
